import React, { useState } from 'react';
import Calculator from './TAA/Calculator';
import { ClockIcon } from '@heroicons/react/solid';
import styled, { keyframes } from 'styled-components';
import { jello } from 'react-animations';

const jelloAnimation = keyframes`${jello}`;

const JelloDiv = styled.div`
  animation: 1s ${jelloAnimation};
`;

export default function LandingPageFive() {
    const [started, getStarted] = useState(false)
    return (
        <div>
            {!started ?
                <section className='py-12 md:py-20 px-5'>
                    <div className='max-w-7xl mx-auto text-black text-center'>

                        <div className='flex items-center justify-center font-serif text-2xl text-black'>
                            <img src="/unitedtaxattorneys.png" alt="United Tax Attorneys" className='h-14 md:h-20' />
                        </div>

                        <h1 className='text-4xl font-extrabold mt-20 mb-10'>Solve Your Tax Problems TODAY</h1>
                        <p className='text-xl my-10'>We just need a few pieces of information to get the application process started.</p>

                        <JelloDiv>
                            <button onClick={() => getStarted(true)}
                                className='text-2xl font-semibold bg-black drop-shadow-md hover:bg-black text-white rounded-lg px-6 py-4'>
                                Get Started
                            </button>
                        </JelloDiv>
                        <p className='text-sm font-base mt-2 flex items-center justify-center'><ClockIcon className="h-4 w-4 mr-1" />Takes 2 minutes</p>
                    </div>
                </section>
                :
                <div className="mt-2">
                    <Calculator />
                </div>
            }

        </div>
    );
}
